import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRisk = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 21 21"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M3.69 10.931c.4.391 1.049.392 1.45.002l2.717-2.646 1.928 1.883a1.04 1.04 0 0 0 1.449 0l2.125-2.074.002-.002 2.172-2.131v1.128c0 .552.459 1 1.024 1 .566 0 1.025-.448 1.025-1V2.54h-4.483c-.566 0-1.024.448-1.024 1s.458 1 1.024 1h.994l-2.185 2.144-1.398 1.364-1.927-1.882c-.4-.39-1.048-.39-1.448-.001L3.692 9.517a.983.983 0 0 0-.001 1.414Z"
      clipRule="evenodd"
    />
    <path d="M3.86 14.136a1.537 1.537 0 1 1 3.073 0v2.213a1.537 1.537 0 0 1-3.073 0zm5.122-.881a1.537 1.537 0 1 1 3.074 0v3.094a1.537 1.537 0 1 1-3.074 0zm5.122-.881a1.537 1.537 0 0 1 3.074 0v3.975a1.537 1.537 0 1 1-3.074 0z" />
  </svg>
);
export default SvgRisk;
